import { useContext } from 'react'
import { PrintingContextProvider } from '../../provider/printing-context.provider'

export const usePrintingContext = () => {
  const context = useContext(PrintingContextProvider)
  if (!context) {
    console.error('usePrintingContext must be used within PrintingProvider')
    throw new Error('usePrintingContext must be used within PrintingProvider')
  }
  return context
}
